import { render, staticRenderFns } from "./permissionPanels.vue?vue&type=template&id=188c6c5a&scoped=true&"
import script from "./permissionPanels.vue?vue&type=script&lang=js&"
export * from "./permissionPanels.vue?vue&type=script&lang=js&"
import style0 from "./permissionPanels.vue?vue&type=style&index=0&id=188c6c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c6c5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
